<kl-grid
  [columns]="[
    { header: 'code' | translate, binding: 'code', width: '*', visible: true },
    {
      header: 'description' | translate,
      binding: 'description',
      width: '*',
      visible: true
    },
    {
      header: 'sales_vat_rate' | translate,
      binding: 'sales_vat_rate',
      width: '*',
      visible: true
    },
    {
      header: 'purch_vat_rate' | translate,
      binding: 'purchase_vat_rate',
      width: '*',
      visible: true
    },
    {
      header: 'persale_vat_rate' | translate,
      binding: 'per_sales_vat_rate',
      width: '*',
      visible: true
    }
  ]"
  definition="Vergi Oranları"
  [filterable]="false"
  [deferResizing]="false"
  [tabId]="tabId || modalId"
  [mode]="'DIALOG'"
  [closeInside]="true"
  [service]="{
    service: 'vatgroup',
    name: 'vat_rate',
    form: 'VAT_RATE',
    showButton: true,
    showDropDownButton: true
  }"
  [parentModuleName]="'APPLICATION_PARAMS'"
  [moduleName]="'VAT_RATE_LIST'"
  [gridName]="'grdVatRateList'"
>
</kl-grid>
